<template>
<div>
  <v-subheader class='overline pl-0' v-if='label' v-text='label' />
  <v-chip
    v-for='location in locations' :key='location.id'
    @click='toggleSelected(location)' >
    <v-icon left
      v-if='isSelected(location)' >check</v-icon>
    {{location.name}}
  </v-chip>
  <div class='caption text--grey mt-2 pl-2' v-if='hint' v-text='hint' />
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'InlineLocationPicker',
  props: {
    spaceId: { required: true },
    value: { required: false },
    label: { type: String, default: 'Choose an address' },
    hint: { type: String, required: false },
    multiple: { type: Boolean, default: true },
    returnObject: { type: Boolean, default: false }
  },
  data () {
    return {
      selected: []
    }
  },
  mounted () {
    if (this.multiple) {
      this.selected = []
    } else {
      this.selected = null
    }
  },
  methods: {
    isSelected (item) {
      if (this.multiple) {
        return (this.selected.indexOf(item.id) > -1)
      } else {
        return item.id === this.selected.id
      }
    },
    toggleSelected (item) {
      if (this.multiple) {
        let index = this.selected.indexOf(item.id)
        if (index > -1) {
          this.selected.splice(index, 1)
        } else {
          if (this.returnObject) {
            this.selected.push(item)
          } else {
            this.selected.push(item.id)
          }
        }
      }
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    }
  },
  computed: {
    ...mapGetters(['locationsBySpace']),
    locations () {
      if (this.spaceId) {
        return this.locationsBySpace(this.spaceId)
      }
      return []
    }
  }
}
</script>



// WEBPACK FOOTER //
// InlineLocationPicker.vue?7c191c4b